export const data = [
    {
        id: "1",
        icon: "./assets/mobile.png",
        desc: "Extensive knowledge of React native for creating responsive cross platform mobile application.",
        img: "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
        title: "Mobile application",
    },
    {
        id: "2",
        icon: "./assets/globe.png",
        desc: "Advanced web design and development skills. Heavy user of React and Node. Still learning MERN fullstack.",
        img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
        title: "Web application",
    },
    {
        id: "3",
        icon: "./assets/writing.png",
        desc: "Beautiful photo manipulation, video editing and logo design. ",
        img: "./assets/videoEditing.png",
        title: "Designing",
    },
];